import API from "./Api";

export default function $download (url) {
    API.get(url)
      .then(({ data }) => {
        let blob = new Blob([data], { type: "image/png" });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "image.png";
        link.click();
      })
      .catch(error => {
        console.error(error);
      })
  }
